<ng-template #content_supplier let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.supplier">
        <div class="side_popup_header">
            <span>{{localService.languageContent.supplier.header}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div>
        <app-tab *ngIf="tabs" [tabs]="tabs" [selectedKey]="selectedTabKey"
            (onTabSelected)="onAction(1,$event)"></app-tab>
    </div>
    <div class="side_popup_body" style="margin: 10px;"
        [ngStyle]="{'max-height' : (localService.sideBarBodyHeight - 50) + 'px'}" *ngIf="supplierInitialization">
        <div *ngIf="selectedTabKey == '1' || selectedTabKey == '2'">
            <div class="row">
                <div class="col-12">
                    <app-language-container [MaxLength]="300" [Title]="localService.languageContent.supplier.name"
                        [(languageContents)]="supplierInitialization.supplier.languageContentsName"
                        (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)"
                        [MandatoryLanguages]="mandatoryLanguages" [id]="elementIds.supplier_name"
                        [nextId]="elementIds.supplier_bar_code" [IsPartiallyMandatory]="true"
                        [IsNeedNewLine]="true"></app-language-container>
                </div>
            </div>
            <div>
                <div class="col-12">
                    <app-label [Text]="localService.languageContent.supplier.bar_code" />
                    <input autocomplete="off" type="text" id="{{elementIds.supplier_bar_code}}"
                        [ngClass]="supplierInitialization.supplier.content.v3 ? 'en' : ''"
                        [(ngModel)]="supplierInitialization.supplier.content.v3"
                        placeholder="{{localService.languageContent.supplier.bar_code}}"
                        title="{{localService.languageContent.supplier.bar_code}}"
                        style="width: calc(100% - 50px);margin-right: 5px;"
                        (keydown.enter)="localService.onFocusNextInput(elementIds.supplier_code, 1)" />
                    <app-qr-scanner (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-label [Text]="localService.languageContent.supplier.supplier_code" />
                    <input autocomplete="off" type="text" id="{{elementIds.supplier_code}}"
                        [ngClass]="supplierInitialization.supplier.content.v1 ? 'en' : ''"
                        [(ngModel)]="supplierInitialization.supplier.content.v1"
                        placeholder="{{localService.languageContent.supplier.supplier_code}}"
                        title="{{localService.languageContent.supplier.supplier_code}}"
                        (keydown.enter)="localService.onFocusNextInput(elementIds.supplier_upi, 1)" />
                </div>
                <div class="col-md-6">
                    <app-label [Text]="localService.languageContent.supplier.supplier_upi" />
                    <input autocomplete="off" type="text" id="{{elementIds.supplier_upi}}"
                        [ngClass]="supplierInitialization.supplier.content.v2 ? 'en' : ''"
                        [(ngModel)]="supplierInitialization.supplier.content.v2"
                        placeholder="{{localService.languageContent.supplier.supplier_upi}}"
                        title="{{localService.languageContent.supplier.supplier_upi}}" />
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="padding: 25px;">
                    <app-supporting-lines [(items)]="supplierInitialization.supporting"></app-supporting-lines>
                </div>
            </div>
        </div>
        <div *ngIf="selectedTabKey == '1' || selectedTabKey == '3'">
            <div class="row">
                <div class="col-12">
                    <app-mapping-container [items]="supplierInitialization.supplier.contactNumbers"
                        (onValuesUpdated)="onValuesUpdated($event,1)" [isOnlyNumbers]="true" [isGrouping]="true"
                        [Title]="localService.languageContent.supplier.contactNumbers"></app-mapping-container>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-mapping-container [items]="supplierInitialization.supplier.emails"
                        (onValuesUpdated)="onValuesUpdated($event,2)" [isGrouping]="true"
                        [Title]="localService.languageContent.supplier.emails">
                    </app-mapping-container>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-language-container [MaxLength]="300" [Title]="localService.languageContent.supplier.address"
                        [IsLargeText]="true"
                        [(languageContents)]="supplierInitialization.supplier.languageContentsAddress"
                        (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,2)"
                        [id]="elementIds.supplier_address"></app-language-container>
                </div>
            </div>
        </div>
        <div *ngIf="selectedTabKey == '1' || selectedTabKey == '4'">
            <div class="row">
                <div class="col-12">
                    <app-language-container [MaxLength]="300" [Title]="localService.languageContent.supplier.notes"
                        [IsLargeText]="true"
                        [(languageContents)]="supplierInitialization.supplier.languageContentsDescription"
                        (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,3)"
                        [id]="elementIds.supplier_notes"></app-language-container>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer">
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <span *ngIf="message != ''"
                    [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
            <div class="col-4" style="text-align: right;">
                <button id="{{elementIds.supplier_save}}" type="button" class="btn btn-primary" (click)="onAction(2)">
                    {{id ? localService.languageContent.common.update :
                    localService.languageContent.common.create}}
                </button>
            </div>
        </div>
    </div>
</ng-template>